/**
 * Created by mauget on 1/23/16.
 */

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import listService      from 'ListService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import DesignerModel     from 'DesignerModel.js';
import WorkflowPageView from 'form/WorkflowPageView.js';

//=============================================================================
//
// Creates one Fabric.js-based page, given a factoryService parameter key.
// The factory parameter defines the  control appearance through its
// specified template. It defines the rectangle of the control via a width
// and height from the factory parameter.
//
// NOTE: pages all share a common set of model property values. E.g. change
// page width, and all pages of a a form change width. Perhaps, we can insure
// that by storing page properties as class (static) properties.
//
// -Lou Mauget, January 23, 2016
//
//=============================================================================
class WorkflowPageFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {
        
        const attributes = this.createChildAttributes(  factoryKey, pos ) ;
        attributes.name = 'Page';
        attributes.width  = 700;
        attributes.height = 900;

        let workflowModel = listService.workflowPage;
        if (!workflowModel) {
            workflowModel = new DesignerModel(attributes);
            listService.workflowPage = workflowModel;
        }

        return new WorkflowPageView( { model: workflowModel, el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: sequenceService.nextDomId() } );
    }

}

const workflowPageFactory = new WorkflowPageFactory();
export default workflowPageFactory;
